<template>
  <!-- eslint-disable -->
  <div style="text-align:left; background-color: rgb(242, 247, 251);">
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNav />
      <div class="main-container">
        <div v-if="loaded" class="articulo-principal">
          <div style="margin-bottom: 20px;">
            <button 
              class="btn-ir-gordo" 
              :style="{
                'background-color': prestador.admin.assets.colors.primary,
                color: 'white',
                display: 'inline-flex',
                'align-items': 'center',
                gap: '8px',
                padding: '10px 20px',
                'border-radius': '8px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }"
              @click="$router.push({ name: 'Profesionales' })"
            >
              <b-icon icon="arrow-left" />
              Volver a Profesionales
            </button>
          </div>
          <div>
            <div style="margin-bottom: 20px;" class="boxy">
              <h4 style=" ">
                Nuevo bloqueo
              </h4>

              <div class="notion-filter">
                Profesional
                <select v-model="pro_id" style="padding:4px;">
                  <option :value="0">
                    Todos
                  </option>
                  <option v-for="p in profesionales" :value="p.id">
                    {{ p.nombre + " " + p.apellido }}
                  </option>
                </select>
                Feriado rápido
                <select
                  v-model="feriadoSeleccionado"
                  @change="seleccionarFeriado"
                  style="padding:4px;"
                >
                  <option value="">Seleccionar feriado...</option>
                  <option v-for="f in feriados" :value="f.fechaISO">
                    {{ f.nombre }} ({{
                      f.fechaISO
                        .split("-")
                        .reverse()
                        .join("-")
                    }})
                  </option>
                </select>

                Dia inicio <input id="x2" v-model="dt_dia" type="date" /> Dia
                termino <input id="x2" v-model="dt_dia2" type="date" />
                Desde
                <select v-model="desde_general" style="padding:4px;">
                  <option
                    v-for="v in Math.round(1440 / 5)"
                    :value="(v - 1) * 5"
                  >
                    {{ timeConvert((v - 1) * 5) }}
                  </option>
                </select>
                Hasta
                <select v-model="hasta_general" style="padding:4px;">
                  <option
                    v-for="v in Math.round(1440 / 5)"
                    v-if="v * 5 > desde_general"
                    :value="v * 5"
                  >
                    {{ timeConvert(v * 5) }}
                  </option>
                </select>
                <button
                  style="margin-left:8px;"
                  class="menuCol btn-ir-gordo"
                  :style="{
                    'background-color': prestador.admin.assets.colors.primary,
                    color: 'white'
                  }"
                  @click="agregar_bloqueo()"
                >
                  Agregar Bloqueo
                  <b-icon
                    style="transform:translateY(2px);"
                    icon="plus-circle"
                  />
                </button>
              </div>
            </div>
            <div class="boxy">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                <h4 style="margin: 0;">
                  Bloqueos existentes
                </h4>
                <div>
                  <label style="margin-right: 10px; font-weight: 500; font-size: 0.9rem; color: #333;">Filtrar por Profesional:</label>
                  <select v-model="filtro_profesional" style="padding: 0.5rem 0.75rem; border: 1px solid #d1d5db; border-radius: 8px; font-size: 0.95rem; outline: none; width: 200px; background-color: white;">
                    <option :value="0">Todos</option>
                    <option v-for="p in profesionales" :value="p.id">
                      {{ p.nombre + " " + p.apellido }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="schedule-table-container">
                <table class="schedule-table">
                  <thead class="bg-gray-100">
                    <td style="padding:10px;">
                      <b class="px-4 py-2 text-left">Nombre</b>
                    </td>
                    <td style="padding:10px;">
                      <b class="px-4 py-2 text-left">Fecha</b>
                    </td>
                    <td style="padding:10px;">
                      <b class="px-4 py-2 text-left">Horario</b>
                    </td>
                    <td style="padding:10px; text-align:center;">
                      <b class="px-4 py-2 text-left">Eliminar</b>
                    </td>
                  </thead>
                  <tr class="border-t" v-for="b in bloqueosFiltrados">
                    <td class="px-4 py-2">
                      <span
                        v-if="
                          profesionales.some(z => {
                            return z.id == b.profesional;
                          })
                        "
                        >{{
                          profesionales.filter(x => {
                            return x.id == b.profesional;
                          })[0].nombre +
                            " " +
                            profesionales.filter(x => {
                              return x.id == b.profesional;
                            })[0].apellido
                        }}</span
                      >
                    </td>
                    <td class="px-4 py-2">
                      {{
                        new Date(
                          b.fecha.a,
                          b.fecha.m - 1,
                          b.fecha.d
                        ).toLocaleDateString("es-ES", {
                          year: "numeric",
                          month: "long",
                          day: "numeric"
                        })
                      }}
                    </td>
                    <td class="px-4 py-2">
                      {{ timeConvert(b.desde) + " - " + timeConvert(b.hasta) }}
                      hrs
                    </td>
                    <td style="padding:10px; text-align:center;">
                      <b-icon
                        icon="trash"
                        style="color:red; cursor:pointer;"
                        @click="borrar_bloqueo(b.id)"
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="articulo-principal">
          <div
            style="height: calc(100vh - 140px); display: flex; justify-content: center; align-items: center;"
          >
            <Loader :height="100" :width="100" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import SideNav from "@/components/SideNav.vue";
import Loader from "@/components/Loader.vue";
import TopNav from "@/components/TopNav.vue";

export default {
  name: "HelloWorld",
  //props:['id'],
  components: {
    SideNav,
    Loader,
    TopNav
  },
  data() {
    return {
      dias: ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Dom"],
      dias2: [
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sabado",
        "Domingo"
      ],
      loaded: false,

      dt_dia: "",
      dt_dia2: "",
      pro_id: 0,
      dia_general: { d: 0, m: 0, a: 0 },
      dia_general2: { d: 0, m: 0, a: 0 },
      profesionales: [],
      bloqueos: [],
      periodo: 60,
      desde_general: 0,
      hasta_general: 0,
      profesional_id: 0,

      feriadoSeleccionado: "",
      feriados: [],
      filtro_profesional: 0
    };
  },
  created() {
    this.initialize_();
  },

  methods: {
    ...mapActions(["initialize"]),

    agregar_bloqueo() {
      axios
        .post(window.hostname + "/api/admin/admin_agregar_bloqueos", {
          id: this.pro_id,
          desde: this.desde_general,
          hasta: this.hasta_general,
          d: this.dia_general.d,
          m: this.dia_general.m,
          a: this.dia_general.a,
          d2: this.dia_general2.d,
          m2: this.dia_general2.m,
          a2: this.dia_general2.a
        })
        .then(response => {
          this.initialize_();
        })

        .catch(e => {
          console.log("Error al cargar...");
        });
    },
    async cargarFeriados() {
      try {
        const res = await axios.get("https://api.boostr.cl/holidays.json", {
          headers: {
            accept: "application/json",
            "user-agent":
              "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36"
          }
        });

        const feriadosRaw = res.data?.data || [];

        this.feriados = feriadosRaw.map(f => ({
          nombre: f.title,
          fechaISO: f.date,
          tipo: f.type,
          inalienable: f.inalienable,
          extra: f.extra
        }));
      } catch (error) {
        this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: 'Error al cargar feriados',
          type: 'error'
        });
      }
    },

    seleccionarFeriado() {
      if (!this.feriadoSeleccionado) return;

      const feriado = this.feriados.find(
        f => f.fechaISO === this.feriadoSeleccionado
      );
      if (!feriado) return;

      const fechaISO = feriado.fechaISO;

      this.dt_dia = fechaISO;
      this.dt_dia2 = fechaISO;

      this.desde_general = 0;
      this.hasta_general = 1440;
    },

    borrar_bloqueo(bid) {
      axios
        .post(window.hostname + "/api/admin/admin_borrar_bloqueos", { id: bid })
        .then(response => {
          this.initialize_();
        })

        .catch(e => {
          console.log("Error al cargar...");
        });
    },

    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return (
        (rhours < 10 ? "0" : "") +
        rhours +
        ":" +
        (rminutes < 10 ? "0" : "") +
        rminutes +
        ""
      );
    },

    initialize_() {
      this.loaded = false;
      axios
        .get(window.hostname + "/api/admin/initialize_bloqueos")
        .then(r => {
          this.loaded = true;
          this.profesionales = r.data.profesionales;
          this.bloqueos = r.data.bloqueos;
        })
        .catch(r => {
          this.loaded = true;
        });
    },

    agregar_horario(agenda_id, inicio, termino, repeticion) {
      var error_msg = "";
      if (agenda_id == 0) error_msg = "Por favor, ingrese una agenda. ";
      if (inicio == -1) error_msg += "Por favor, ingrese una hora de inicio. ";
      if (termino == -1)
        error_msg += "Por favor, ingrese una hora de término. ";

      if (inicio > termino)
        error_msg += "La hora de inicio no puede ser mayor a la de término. ";
      var x = "";
      for (var i = 0; i < repeticion.length; i++)
        x += repeticion[i].value.toString();

      if (x == "0000000") error_msg += "Debes especificar al menos un día. ";

      if (error_msg == "") {
        axios
          .post(window.hostname + "/api/admin/addHorario", {
            profesional_id: agenda_id,
            inicio: inicio,
            termino: termino,
            repeticion: x
          })
          .then(resp => {
            this.$notify({
              duration: 5000,
              title: "Horario agregado",
              text: "¡Se ha añadido el horario a la base de datos!",
              type: "success"
            });
            this.initialize_(this.$route.params.id);
          })
          .catch(e => {
            this.$notify({
              duration: 5000,
              title: "Error!",
              text: e.response.data.message,
              type: "error"
            });
          });
      } else {
        this.$notify({ title: "Error", text: error_msg, type: "error" });
      }
    }
  },
  computed: {
    ...mapGetters([
      "comunas",
      "regiones",
      "prestaciones",
      "prestador",
      "admin_datos",
      "examenes"
    ]),
    bloqueosFiltrados() {
      if (this.filtro_profesional === 0) {
        return this.bloqueos;
      }
      return this.bloqueos.filter(b => b.profesional === this.filtro_profesional);
    }
  },
  watch: {
    dt_dia(val) {
      var datos = val.split("-");
      this.dia_general = {
        a: Number(datos[0]),
        m: Number(datos[1]),
        d: Number(datos[2])
      };
    },
    dt_dia2(val) {
      var datos = val.split("-");
      this.dia_general2 = {
        a: Number(datos[0]),
        m: Number(datos[1]),
        d: Number(datos[2])
      };
    }
  },
  mounted() {
    this.cargarFeriados();

    var hoy = new Date();
    this.dt_dia = hoy.toISOString().split("T")[0];
    this.dt_dia2 = hoy.toISOString().split("T")[0];
  }
};
</script>

<style scoped>
td {
  text-align: left;
}

.articulo-principal {
  min-height: Calc(100vh - 120px);
  max-width: 1390px;

  margin: 0 auto;
}

.notion-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
    background: rgba(255, 255, 255, 0.7);
    padding: 1rem;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.notion-filter label {
    display: block;
    font-size: 0.9rem;
    font-weight: 500;
    color: #333;
    margin-bottom: 0.25rem;
}

.notion-filter select {
    width: 160px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background-color: #fff;
    font-size: 0.95rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.notion-filter select {
    outline: none;
    border-color: #a8a8a8;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
}

.notion-filter input[type="date"] {
    width: 160px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background-color: #fff;
    font-size: 0.95rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.notion-filter input[type="date"]:focus {
    outline: none;
    border-color: #a8a8a8;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
}

.notion-filter .button-container {
    align-self: flex-end;
}

.notion-filter button {
    background-color: #f3f3f3;
    color: #111;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    font-size: 0.95rem;
    cursor: pointer;
    transition: background-color 0.2s, box-shadow 0.2s;
}

.notion-filter button:hover {
    background-color: #eaeaea;
}

.notion-filter button:active {
    background-color: #dddddd;
}

.column-right {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    padding-top: 0px;
    padding-left: 275px;
    width: 100%;
    min-height: 100vh;
}

.boxy {
  background-color: white;
  padding: 20px;
  box-shadow: 0 0.125rem 0.25rem rgba(165, 163, 174, 0.3);
  border-radius: 8px;
}

.schedule-table-container {
    overflow-x: auto;
}

.schedule-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: 8px;
    overflow: hidden;
}

.schedule-table td {
    background: #f8fafc;
    padding: 1rem;
    text-align: left;
    font-weight: 600;
    color: #64748b;
    font-size: 0.875rem;
    border-bottom: 1px solid #e2e8f0;
}

.schedule-table tr {
    padding: 1rem;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: top;
}

.schedule-row:hover {
    background-color: #f8fafc;
}
.column-right {
  background-color: var(--background-primary);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}
.main-container {
  background-color: var(--background-primary);
  padding: 24px;
  margin-top: 10px;
}
@media (max-width: 800px) {
  .column-right {
    padding-left: 0px;
  }
}
@media (max-width: 1200px) {
  .column-right {
    padding-left: 0px;
  }
}
</style>
